
export function voiceBookmarkKey(voice: { code: string; engine: string } | Record<string, any>): string {
    return `${voice.code}#${voice.engine}`;
}
